export default __webpack_public_path__ + "static/media/arrowRightBlack.8a27330c.svg";